module.exports = __webpack_public_path__ + "static/media/Dallas_Stars.b69ea95b.svg";